export const order_status = {
    'PENDING': 1,
    'PREPARING': 2,
    'DELIVERING': 3,
    "DELIVERED": 4,
    "REJETED_RIDER": 5,
    "REJECTED_STOCK": 6,
    "REJECTED_FAKE": 7,
}